import i18n from '@risksmart-app/i18n/src/i18n';

import { t } from '../../i18n-t';
import type { FormConfig } from '../types';

export const getAppetiteFormConfig = (postureFeatureEnabled: boolean) => {
  return {
    AppetiteType: {
      fieldId: 'AppetiteType',
      formLabel: t(`appetites.columns.appetiteType`),
      columnHeader: t(`appetites.columns.appetiteType`),
    },
    Statement: {
      fieldId: 'Statement',
      formLabel: t(`appetites.columns.statement`),
      columnHeader: t(`appetites.columns.statement`),
      allowTargetConditions: true,
      displayType: { displayType: 'textarea' },
    },
    LowerAppetite: {
      fieldId: 'LowerAppetite',
      formLabel: t(`appetites.columns.lowerAppetite`),
      columnHeader: t(`appetites.columns.lowerAppetite`),
      displayType: { displayType: 'rating', ratingKey: 'risk_appetite' },
      allowAsConditionSource: true,
    },
    UpperAppetite: {
      fieldId: 'UpperAppetite',
      // This mirrors the current behaviour of the UI, however could lead to unusual behaviour is a user renamed the feature, then changes the posture setting.
      formLabel: postureFeatureEnabled
        ? t(`appetites.columns.posture`)
        : t(`appetites.columns.upperAppetite`),
      columnHeader: postureFeatureEnabled
        ? t(`appetites.columns.posture`)
        : t(`appetites.columns.upperAppetite`),
      displayType: { displayType: 'rating', ratingKey: 'risk_appetite' },
      allowAsConditionSource: true,
    },
    LikelihoodAppetite: {
      fieldId: 'LikelihoodAppetite',
      formLabel: t(`appetites.columns.likelihoodAppetite`),
      columnHeader: t(`appetites.columns.likelihoodAppetite`),
      displayType: { displayType: 'rating', ratingKey: 'likelihood_appetite' },
      allowAsConditionSource: true,
    },
    ImpactId: {
      fieldId: 'ImpactId',
      formLabel: i18n.format(t('impact'), 'capitalize'),
      columnHeader: i18n.format(t('impact'), 'capitalize'),
    },
    ImpactAppetite: {
      fieldId: 'ImpactAppetite',
      formLabel: t('impactAppetite'),
      columnHeader: t('impactAppetite'),
      displayType: { displayType: 'rating', ratingKey: 'impact_appetite' },
      allowAsConditionSource: true,
    },
    EffectiveDate: {
      fieldId: 'EffectiveDate',
      formLabel: t(`appetites.columns.effectiveDate`),
      columnHeader: t(`appetites.columns.effectiveDate`),
      displayType: { displayType: 'date' },
      allowTargetConditions: true,
      allowAsConditionSource: true,
    },
    files: {
      fieldId: 'files',
      formLabel: t(`fields.newFiles`),
      allowTargetConditions: true,
    },
  } as const satisfies FormConfig;
};
